module.exports = __webpack_public_path__ + "img/freezing_drizzle.a5c6c775.svg";